// extracted by mini-css-extract-plugin
module.exports = {"grid-container-block":"grid-container-block_grid-container-block__RwJHI","grid-container-block__full-width":"grid-container-block_grid-container-block__full-width__MoN0P"};